import { useSelector, useDispatch } from "react-redux";
import { Container, Stack, Typography } from "@mui/material";

import AutocompleteWithTags from "components/AutocompleteWithTags";

import { setCategories, selectCategories } from "../slice";

const categoryOptions = [
    "Animal Welfare",
    "Art & Culture",
    "Community",
    "Education", // B, minus universities
    "Environment",
    "Health", // E, F, G, H, minus hospitals
    "Hospitals", // E20, E21, E22, E24 — if available
    "International Relief",
    "Other",
    "Religion",
    "Social & Human Services",
    "Sports & Recreation",
    "Universities", // B40, B41, B42, B43, B50 — if available
];

const categoryOptionsList = categoryOptions.map((label) => ({ label }));

const CategoriesStep = () => {
    const dispatch = useDispatch();
    const categories = useSelector(selectCategories);

    const handleChange = (newValue) => {
        dispatch(setCategories(newValue));
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 2 }}>
            <Stack alignItems="center" gap={1.5}>
                <Typography fontWeight="500" color="text.mediumDark">
                    Select your organization’s sectors
                </Typography>

                <AutocompleteWithTags
                    placeholder="Search sectors..."
                    list={categoryOptionsList}
                    selectedValues={categories}
                    onChange={handleChange}
                />
            </Stack>
        </Container>
    );
};

export default CategoriesStep;
